import {
  // AnyFieldValue,
  DynamicSchemaField,
  FileIdsValue,
  Files,
  SelectMultipleValue,
} from '@kaizenplatform/hugot-entity';
import { Set } from 'immutable';

import {
  AssetCategoryDefinitionForProjectFragment,
  CreativeBriefDefinitionForProjectFragment,
  DynamicSchemaDefinitionField,
} from '../generated/graphql';

export const adaptForTheDefinition = (
  values: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>,
  definition: CreativeBriefDefinitionForProjectFragment,
) => {
  const fields = definition.sections.flatMap((section) => section.fields);
  return new Map(
    fields
      .map((field) => DynamicSchemaField.fromJSON(field))
      .map<[string, string | number | boolean | SelectMultipleValue | FileIdsValue | null]>((field) => {
        if (field instanceof Files) {
          return [field.key, field.getDefaultValue()];
        }
        return [field.key, field.getAdaptedValue(values.get(field.key))];
      }),
  );
};

export const valuesToJSON = (
  values: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>,
) => {
  const json: { [key: string]: string | number | boolean | SelectMultipleValue | FileIdsValue | null } = {};
  values.forEach((value, key) => {
    if (value instanceof Set) {
      json[key] = (value as Set<string>).toArray();
    } else {
      json[key] = value;
    }
  });
  return json;
};

export const createWithDefinition = (definition: AssetCategoryDefinitionForProjectFragment) => {
  const json: { [key: string]: string | number | boolean | SelectMultipleValue | FileIdsValue | null } = {};
  const fields = definition.sections.flatMap((section) => section.fields);
  const values = new Map(
    filterBlankAssetCategorySectionsField(fields)
      .map((field) => DynamicSchemaField.fromJSON(field))
      .map((field) => {
        const value = field.type === 'SELECT_MULTIPLE' ? Set(json[field.key] as SelectMultipleValue) : json[field.key];
        return [field.key, field.getAdaptedValue(value)];
      }),
  );
  return values;
};

export const filterBlankAssetCategorySectionsField = (
  fields: Array<Pick<DynamicSchemaDefinitionField, 'type' | 'key'> | Record<string, never>>,
): Array<Pick<DynamicSchemaDefinitionField, 'type' | 'key'>> =>
  fields.filter((f): f is Pick<DynamicSchemaDefinitionField, 'type' | 'key'> => !!f.key);
